<template>
  <div id="select-checkin-flight">
    <div class="flight-list flex">
      <a-radio-group @change="onChange">
        <div class="flight-item clearfix" v-for="(flight,index) in checkinList" :key="index">
          <div class="flight-info clearfix">
            <div class="checkbox">
              <a-radio :value="index" :disabled="flight.disabled" style="margin: 0"></a-radio>
              <p>请选择</p>
            </div>
            <div :class="['airline-logo', 'logo', `logo-${flight.airline.toLocaleLowerCase()}`]"></div>
            <div class="flight-time clearfix">
              <div class="dep-info">
                <p>{{flight.depTimeFormat}}</p>
                <p class="city">{{flight.depAirportName}}</p>
              </div>
              <div class="route">
                <p>{{flight.flightNo}}</p>
                <div class="line"></div>
                <p>{{flight.depDateFormat}}</p>
              </div>
              <div class="dest-info">
                <p>{{flight.arrTimeFormat || '-'}}</p>
                <span class="gt-day">{{ flight | getDaySpan('depTime', 'arrTime') }}</span>
                <p class="city">{{flight.arrAirportName}}</p>
              </div>
            </div>
            <div class="cabin">
              <p>{{flight.cabin}}</p>
              <p>
                <span>舱位</span>
              </p>
            </div>
            <div class="status">
              <p>{{flight.statusText}}</p>
              <p>
                <span>航班状态</span>
              </p>
            </div>
          </div>
          <div class="passneger-info">
            <p class="name">{{flight.passengerName}}</p>
            <p>凭证类型：{{certTypeMap[flight.certType]}}</p>
            <p>凭证号：{{codeMask(flight.certNo, {offset: 4, length: 10})}}</p>
            <p v-if="flight.phone">手机号：{{flight.phone}}</p>
          </div>
        </div>
      </a-radio-group>
    </div>
  </div>
</template>
<script>
import { getDaySpan } from '@/filters/time'
import codeMask from '@/assets/js/codeMask'

const certTypeMap = {
  'NI': '身份证',
  'PP': '护照',
  'TN': '电子客票'
}
export default {
  props: {
    checkinList: { type: Array }
  },
  data () {
    return {
      certTypeMap,
      codeMask
    }
  },
  methods: {
    onChange (e) {
      this.$emit('selectTrip', e.target.value)
    }
  },
  filters: {
    getDaySpan
  }
}
</script>

<style lang="less" scoped>
.flight-list {
  border: 1px solid #bfbfbf;
}
.flight-item:nth-child(1) {
  border-top: 0;
}
.flight-item {
  margin: 0 10px;
  padding: 10px 0;
  border-top: 1px solid #dfdfdf;
  .flight-info {
    float: left;
    width: 938px;
    padding: 20px 10px;
    border-right: 1px dashed #d0d0d0;
    .checkbox {
      float: left;
      width: 45px;
      padding-top: 15px;
      text-align: center;
      color: #808080;
      font-size: 12px;
      line-height: 24px;
    }
    .logo {
      float: left;
      width: 48px;
      height: 59px;
      margin: 0 30px;
      margin-top: 5px;
    }
    .flight-time {
      float: left;
      width: 460px;
    }
    .dep-info,
    .dest-info {
      float: left;
      width: 150px;
      margin-top: 5px;
      text-align: center;
      font-weight: bold;
      position: relative;
      .gt-day {
        position: absolute;
        top: 0;
        right: -5px;
        font-size: 12px;
        color: @primary-color;
      }
      p {
        font-size: 24px;
        line-height: 32px;
        color: #000;
      }
      p.city {
        font-weight: normal;
        font-size: 14px;
      }
    }
    .route {
      float: left;
      width: 120px;
      margin: 0 15px;
      font-size: 12px;
      line-height: 36px;
      text-align: center;
      color: #808080;
      .line {
        border-bottom: 1px solid #d0d0d0;
      }
    }
    .cabin,
    .status {
      float: left;
      width: 80px;
      margin: 0 20px;
      margin-top: 10px;
      text-align: center;
      font-size: 18px;
      line-height: 26px;
      color: #000;
      font-weight: bold;
      span {
        font-weight: normal;
        font-size: 12px;
        color: #808080;
      }
    }
    .cabin {
      margin-left: 60px;
    }
  }
  .passneger-info {
    float: left;
    width: 340px;
    padding: 15px 10px 15px 78px;
    text-align: left;
    p {
      font-size: 14px;
      line-height: 24px;
      color: #808080;
    }
    p.name {
      font-size: 18px;
      color: #000;
      margin-bottom: 15px;
      font-weight: bold;
    }
  }
}
@media only screen and (max-width: 768px) {
  .flight-list {
    width: 96%;
    overflow-x: scroll;
    margin: 0 auto;
  }
  .flight-item {
    .logo {
      display: none;
    }
    .flight-info {
      width: 600px;
      padding: 10px 5px;
      border-right: 0;
      .flight-time {
        width: 300px;
      }
      .route {
        width: 100px;
        margin: 0 10px;
      }
      .cabin {
        margin-left: 20px;
        margin-right: 30px;
      }
      .status {
        margin-left: 20px;
        margin-right: 0;
      }
    }
    .passneger-info {
      width: 600px;
      padding-top: 15px;
      padding-left: 60px;
      p.name {
        display: block;
      }
      p {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
